import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";
import select_circle from "../../Assets/Images/icons/select_rectangle.png"
import unselect_circle from "../../Assets/Images/icons/unselect_rectangle.png"
import { IoMdClose } from "react-icons/io";
import moment from "moment";
import NodeaxiosInstance from "../../Services/nodeaxios";
import CenterLoginNavigateModal from "../../Components/modal/centerSmallModal";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import Kitchen_ticket from "../../Components/kichen_tickct/kitchen_ticket";
import { MdCircle } from "react-icons/md";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { RiEBike2Fill } from "react-icons/ri";
import { FaClock } from "react-icons/fa";
import { CgDanger } from "react-icons/cg";
import { FaArrowRight } from "react-icons/fa6";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import "./kitchen.css";


export default function Single_kitchen_ticket_detail() {

    const [data, setData] = useState();

    const { vendor_id, ticket_id } = useParams();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const navigate = useNavigate();
    const location = useLocation()
    const { select_date, type, prevsDate } = location.state || {};

    const [showModal, setShowModal] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const [isTouch, setIsTouch] = useState(false);
    const shippingtypeRef = useRef(null)
    const [shipping_type, setShiping_type] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [timeLeft, setTimeLeft] = useState(null);
    const DEFAULT_Ticket_IMAGE_URL = "https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/FoodPlaceholderRect.png";
    const DEFAULT_IMAGE_URL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";
    const [expiredStatus, setExpiredStatus] = useState(false)
    const [selectedDate, setSelectedDate] = useState(select_date);
    const [quantity, setQuantity] = useState(1);

    const increaseQuantity = () => {
        setQuantity(prev => prev + 1);
    };

    const decreaseQuantity = () => {
        setQuantity(prev => (prev > 1 ? prev - 1 : 1));
    };

    let finalDate = ''

    const handleTouch = () => {
        setIsTouch(!isTouch);
    };

    const openShippingModal = () => {
        if (shippingtypeRef.current) {
            shippingtypeRef.current.classList.add("show");
            shippingtypeRef.current.style.display = "block";
            setIsModalOpen(true)
        } else {
            console.warn("shippingtypeRef is null");
        }
    };


    const closeShippingModal = () => {
        shippingtypeRef.current.classList.remove("show");
        shippingtypeRef.current.style.display = "none";
        setIsModalOpen(false)

    }


    useEffect(() => {
        fetch_ticket_deta()
    }, [])

    const fetch_ticket_deta = async () => {
        try {
            const today = moment().format("DD-MM-YYYY");

            const headers = { Authorization: userData?.token };

            // Get stored date or fallback to today
            let localpreviesdate = localStorage.getItem("previesdate")
                ? JSON.parse(localStorage.getItem("previesdate"))
                : today;

            finalDate = moment(localpreviesdate, ["DD-MM-YYYY", "D MMMM YYYY"])
                .toDate()
                .toDateString();

            // setSelectedDate(finalDate);
            //  const apiDate = parsedDate.format("MM-DD-YYYY");

            // API call
            const response = await NodeaxiosInstance.get("/kitchen/fetch-single-ticket", {
                params: {
                    vendor_id: vendor_id,
                    date: finalDate,
                    type: type,
                    ticket_id: ticket_id,
                },
                headers,
            });

            if (response.status == 200) {
                setPageLoaded(true);
                setData(response.data);
                //   setErrorMessage(""); // clear any previous error 
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }

        } catch (error) {
            console.error("Error fetching ticket details:", error);
            setPageLoaded(false);
            // setErrorMessage("Failed to load ticket details. Please try again later.");

            showToast("Something went wrong. Please try again later.")

        }
    };


    const add_to_cart = () => {
        try {


            const finalDate = moment(selectedDate, ["DD-MM-YYYY", "D MMMM YYYY"]).format("YYYY-MM-DD");
            let reqData = {
                "vendor_id": vendor_id,
                "date": select_date,
                "ticket_id": ticket_id,
                "type": type,
                "shipping_type": shipping_type,
                "quantity": quantity,
            }

            NodeaxiosInstance.post("/kitchen/add-cart", reqData)
                .then((res) => {
                    if (res.status == 200) {

                        let productCart = {
                            cartId: res.data.cartId,
                            vendorId: vendor_id
                        };
                        localStorage.setItem("kitchen_Cart", JSON.stringify(productCart));
                        navigate("/Review-Pay");
                    }
                });

        } catch (error) {
            showToast("Something went wrong. Please try again later.")
        }
    }

    useEffect(() => {
        const checkIfExpired = () => {
            const now = moment();
            const bookBefore = data?.ticket_detail?.bookBefor;
            let deadline = moment(bookBefore);

            setExpiredStatus(now.isAfter(deadline) ? true : false);
        };

        checkIfExpired();

    }, [data]);


    useEffect(() => {
        if (!data?.ticket_detail?.bookBefore || data?.ticket_detail?.bookBefore == "0") return;
        const endTime = moment(data?.ticket_detail?.bookBefore);
        const now = moment();

        if (now.isAfter(endTime)) {
            setTimeLeft(0);
            return;
        }

        setTimeLeft(endTime.diff(now, "seconds"));

        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [data?.ticket_detail?.bookBefore]);


    // The discount only covers the tickets still allowed (overall limit and per-user cap); the rest cost the normal price
    const ticketDetail = data?.ticket_detail;
    const normalTicketPrice = Number(ticketDetail?.ticket_price || 0);
    const discountTicketPrice = ticketDetail?.discount_available ? Number(ticketDetail?.discount || 0) : 0;
    const discountedTicketCount = discountTicketPrice > 0
        ? Math.min(quantity, ticketDetail?.discount_remaining ?? Infinity, ticketDetail?.discount_user_remaining ?? Infinity)
        : 0;
    const totalTicketPrice = discountedTicketCount * discountTicketPrice + (quantity - discountedTicketCount) * normalTicketPrice;

    // Discount details for the info cards (limits are set by the merchant on the ticket)
    // Hidden once this user has already used their discount, so it doesn't look like it is still on offer
    const hasDiscountConfigured = ticketDetail?.discount_status == 1
        && Number(ticketDetail?.discount_amount) > 0
        && Number(ticketDetail?.discount_amount) < normalTicketPrice
        && ticketDetail?.discount_user_remaining !== 0;
    const discountLimitEnabled = ticketDetail?.discount_usage_limit_status == 1 && Number(ticketDetail?.discount_usage_limit) > 0;
    const discountLimitTotal = Number(ticketDetail?.discount_usage_limit) || 0;
    const discountTotalRemaining = Number(ticketDetail?.discount_remaining) || 0;
    const discountPerUserLimit = Number(ticketDetail?.discount_per_user) || 0;

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours}h ${minutes}m ${secs}s`;;
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white ">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
                        onClick={() => navigate(`/kitchen_ticket_list/${vendor_id}`, { state: { type: type } })} />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1"> Ticket Details</div>
                </div>
            </div>

            {
                pageLoaded ?
                    <>
                        {/* <div className="p-2 pb-5 mb-2 scroller-style-y">
                            <div className="pb-3">
                                <div>
                                    <Kitchen_ticket Data={data.ticket_detail} fromPage={'single'} />
                                    <hr />
                                </div>
                                <h5 className="p-0 m-0 mt-3 fs-15 ff-poppins-semiBold">Ticket details</h5>
                                <div className="d-flex mt-3">

                                    <div className="d-flex justify-content-center col-6">
                                        <div className="membershipListBox">
                                            <p className="ff-poppins-semiBold m-0 fs-14">Delivery Type</p>
                                            <div className="d-flex align-items-center">
                                                <p className="ff-poppins-semiBold m-0 fs-15 primary-text">
                                                    {
                                                        data?.ticket_detail
                                                            .delivery_type == 1 ? 'Instore' :
                                                            data?.ticket_detail
                                                                .delivery_type == 2 ? 'Doorstep' :
                                                                data?.ticket_detail
                                                                    .delivery_type == 3 ? ' Instore & Doorstep' : ""
                                                    }

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center col-6">
                                        <div className="membershipListBox">
                                            <p className="ff-poppins-semiBold m-0 fs-14">Meal Time</p>
                                            <div className="d-flex align-items-center">
                                                <p className="ff-poppins-semiBold m-0 fs-15 primary-text">
                                                    {data?.ticket_detail?.mealTime_lable}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center col-6 mt-3">
                                    <div className="membershipListBox">
                                        <p className="ff-poppins-semiBold m-0 fs-14">Available count</p>
                                        <div className="d-flex align-items-center">
                                            <p className="ff-poppins-semiBold m-0 fs-15 primary-text">
                                                {data?.ticket_detail?.quantity_type == "1" ? `Limited - ${data?.ticket_detail?.quantity_count}` : "Unlimited"}

                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    data?.ticket_detail?.products &&
                                    <div className=" mt-3">
                                        <h5 className="fs-15 ff-poppins-semiBold p-0">{data?.ticket_detail?.products?.length > 1 ? 'Products' : 'Product'} </h5>
                                        {
                                            data?.ticket_detail?.products?.map((item, index) => {
                                                return (
                                                    <div className="d-flex secondary-box p-2 mt-2 rounded-3">
                                                        <div>
                                                            <img src={item.product_image ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.product_image}`
                                                                : DEFAULT_IMAGE_URL} onError={(e) => e.target.src = DEFAULT_Ticket_IMAGE_URL} height="80px" width="80px" className="rounded-3" />
                                                        </div>
                                                        <div className="ms-3">
                                                            <div className="d-flex mt-1">
                                                                <img src={`${item.food_type == 1 ? vegIcon : item.food_type == 2 ? nonvegIcon : ""}`} height="13px" width="13px" className="me-1 mt-1" />
                                                                <span className="p-0 m-0 fs-13 ff-poppins-medium" >{item.product_name} </span>
                                                            </div>
                                                            <p className="p-0 m-0 fs-12 primary-text ff-poppins-medium" >{item.category_name} </p>
                                                            <p className="p-0 m-0 fs-11 primary-text ff-poppins-regular" >{item?.product_quantity_value}  {
                                                                item.product_quantity == 1 ? 'Grams' :
                                                                    item.product_quantity == 2 ? 'Kg(s)' :
                                                                        item.product_quantity == 3 ? 'Ml' :
                                                                            item.product_quantity == 4 ? 'Liters(s)' :
                                                                                item.product_quantity == 5 ? ' Pieces' : ''} </p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                <div className="mb-4 mt-3">
                                    <h6 className=" fs-15 ff-poppins-semiBold">Terms & condition </h6>
                                    <div className="ms-2">
                                        {
                                            data?.ticket_detail?.selected_terms && Array.isArray(JSON.parse(data?.ticket_detail?.selected_terms)) &&
                                            JSON.parse(data?.ticket_detail?.selected_terms).map((item, index) => (
                                                <div className="mt-2  mb-2 d-flex" key={index}>
                                                    <div className="p-0 m-0 fs-8 mt-1 ff-poppins-semi-Bold">
                                                        <MdCircle />
                                                    </div>
                                                    <p className="p-0 m-0 fs-12 ms-2 ff-poppins-regular">{item}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div >
                        {!expiredStatus &&
                            <div className="bottom-btn-container ">
                                <button className="bottom-btn primary-bg " onClick={() => openShippingModal()}  >
                                    Buy Now
                                </button>
                            </div>} */}

                        <div className="scroller-style-y">

                            <div className="kitchen-singletic-container ">
                                <div>
                                    <section className="section-spaces">
                                        <div className="kitchen-singletic-card group">
                                            <div className="kitchen-singletic-image-wrapper">

                                                <img src={data?.ticket_detail?.ticket_img
                                                    ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_detail?.ticket_img}`
                                                    : DEFAULT_Ticket_IMAGE_URL}
                                                    alt="Chicken Biryani"
                                                    className="kitchen-singletic-image"
                                                />

                                                <div className="kitchen-singletic-overlay" ></div>

                                                {/* <span className="kitchen-singletic-timer-badge">
                                               2h:34m
                                            </span> */}

                                                <div className="kitchen-singletic-content">
                                                    {/* <span className="kitchen-singletic-badge">
                                                    Limited Availability
                                                </span> */}

                                                    <h2 className="kitchen-singletic-title">
                                                        {/* <img src={data?.ticket_detail?.food_type == "1" ? vegIcon : nonvegIcon} alt={data?.ticket_detail?.food_type} className="kitchen-singletic-foodicon me-1" /> */}

                                                        {data?.ticket_detail?.ticket_name}
                                                    </h2>

                                                    {/* <p className="kitchen-singletic-subtitle">
                                                    Authentic slow-cooked feast
                                                </p> */}
                                                </div>

                                            </div>
                                        </div>
                                    </section>

                                    <section className="section-spaces">
                                        <h3 className="kitchen-singletic-desc-title">Description</h3>
                                        <p className="kitchen-singletic-desc">{data?.ticket_detail?.about} </p>
                                    </section>

                                    <section className="section-spaces">
                                        {/* <div className="info-grid">
                                        <div className="info-card">
                                            <div>
                                                <div className="info-header">
                                                    <span className="info-label">Delivery<br /> Type</span>
                                                </div>
                                                <p className="info-value"> {
                                                    data?.ticket_detail
                                                        .delivery_type == 1 ? 'Instore' :
                                                        data?.ticket_detail
                                                            .delivery_type == 2 ? 'Doorstep' :
                                                            data?.ticket_detail
                                                                .delivery_type == 3 ? ' Instore & Doorstep' : ""
                                                }</p>
                                            </div>
                                        </div>

                                        <div className="info-card">
                                            <div>
                                                <div className="info-header">
                                                    <span className="material-symbols-outlined info-icon"><FaClock />
                                                    </span>
                                                    <span className="info-label">Meal Time</span>
                                                </div>
                                                <p className="info-value">{data?.ticket_detail?.mealTime_lable}</p>
                                            </div>
                                        </div>
                                    </div> */}

                                        <div className="info-grid mt-2">

                                            <div className="info-card">
                                                <div className="info-header">
                                                    <RiEBike2Fill />
                                                    <span className="info-label">Delivery Type</span>
                                                </div>

                                                <p className="info-value">
                                                    {
                                                        data?.ticket_detail?.delivery_type == 1 ? 'Instore' :
                                                            data?.ticket_detail?.delivery_type == 2 ? 'Doorstep' :
                                                                data?.ticket_detail?.delivery_type == 3 ? 'Instore & Doorstep' : ""
                                                    }
                                                </p>
                                            </div>

                                            {/* Meal Time */}
                                            <div className="info-card">
                                                <div className="info-header">
                                                    <FaClock />
                                                    <span className="info-label">Meal Time</span>
                                                </div>

                                                <p className="info-value" style={data?.ticket_detail?.mealTime_range ? { lineHeight: "20px" } : undefined}>
                                                    {data?.ticket_detail?.mealTime_lable}
                                                </p>
                                                {data?.ticket_detail?.mealTime_range && (
                                                    <>
                                                        <p className="m-0 fs-12 ff-poppins-regular secondary-text" style={{ lineHeight: "16px" }}>({data.ticket_detail.mealTime_range})</p>
                                                        <p className="m-0 fs-12 ff-poppins-regular secondary-text" style={{ lineHeight: "16px", marginTop: "6px" }}>
                                                            Pickup time - {String(data.ticket_detail.mealTime_range).split(' to ')[0]}
                                                        </p>
                                                    </>
                                                )}
                                            </div>

                                            {/* Available Count */}
                                            <div className="info-card ">
                                                <div className="info-header">
                                                    <span className="info-icon">#</span>
                                                    <span className="info-label">Available Count</span>
                                                </div>

                                                <p className="info-value">
                                                    {data?.ticket_detail?.quantity_type == "1" ? `Limited - ${data?.ticket_detail?.quantity_count}` : "Unlimited"}
                                                </p>
                                            </div>

                                            {/* Discount info: shown when the merchant has set a discount price on this ticket */}
                                            {hasDiscountConfigured && (
                                                <>
                                                    <div className="info-card">
                                                        <div className="info-header">
                                                            <span className="info-icon">₹</span>
                                                            <span className="info-label">Discount Price</span>
                                                        </div>
                                                        <p className="info-value">
                                                            ₹{Number(ticketDetail?.discount_amount)}
                                                            <span style={{ fontSize: 12, color: '#8a8a8a', textDecoration: 'line-through', marginLeft: 6 }}>₹{normalTicketPrice}</span>
                                                        </p>
                                                    </div>

                                                    {discountLimitEnabled && (
                                                        <div className="info-card">
                                                            <div className="info-header">
                                                                <span className="info-icon">#</span>
                                                                <span className="info-label">Discount Limit</span>
                                                            </div>
                                                            <p className="info-value">
                                                                {discountTotalRemaining > 0 ? `${discountTotalRemaining} of ${discountLimitTotal} left` : 'Fully used'}
                                                            </p>
                                                        </div>
                                                    )}

                                                    {discountPerUserLimit > 0 && (
                                                        <div className="info-card">
                                                            <div className="info-header">
                                                                <span className="info-icon">#</span>
                                                                <span className="info-label">Discount Per User</span>
                                                            </div>
                                                            <p className="info-value">
                                                                {`${discountPerUserLimit} ticket${discountPerUserLimit > 1 ? 's' : ''}`}
                                                            </p>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                        </div>
                                    </section>

                                    <section className="section-spaces">
                                        <h3 className="kitchen-products-title">Products Included</h3>

                                        <div className="kitchen-products-card">
                                            {data?.ticket_detail?.products?.map((item, index) => (
                                                <div key={index}>

                                                    <div className="kitchen-singletic-product-item">
                                                        <div className="kitchen-singletic-product-img-box">
                                                            <img src={item.product_image ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.product_image}`
                                                                : DEFAULT_IMAGE_URL} onError={(e) => e.target.src = DEFAULT_Ticket_IMAGE_URL} className="kitchen-singletic-product-img" />
                                                        </div>

                                                        <div className="kitchen-singletic-product-info">
                                                            <h4 className="kitchen-singletic-product-name">{item.product_name}</h4>
                                                            <p className="kitchen-singletic-product-desc">{item.category_name}</p>
                                                            <p className="kitchen-singletic-product-desc">Quantity: {item?.product_quantity_value} {
                                                                item.product_quantity == 1 ? 'Grams' :
                                                                    item.product_quantity == 2 ? 'Kg(s)' :
                                                                        item.product_quantity == 3 ? 'Ml' :
                                                                            item.product_quantity == 4 ? 'Liters(s)' :
                                                                                item.product_quantity == 5 ? 'Pieces' : ''}</p>
                                                        </div>

                                                        {/* <span className="kitchen-singletic-product-qty">{item.product_quantity == 2 ? 'Kg(s)' :
                                                        item.product_quantity == 3 ? 'Ml' :
                                                            item.product_quantity == 4 ? 'Liters(s)' :
                                                                item.product_quantity == 5 ? ' Pieces' : ''}</span> */}
                                                    </div>

                                                    {index != data?.ticket_detail?.products?.length - 1 && (
                                                        <div className="kitchen-singletic-product-divider" />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </section>

                                    <section className="section-spaces">
                                        <div className="kitchen-singletic-terms-section">
                                            <div className="kitchen-singletic-terms-header">
                                                <span className="kitchen-singletic-terms-icon"><CgDanger /></span>
                                                <h3 className="kitchen-singletic-terms-title ">Terms & Conditions</h3>
                                            </div>
                                            <ul className="kitchen-singletic-terms-list">
                                                {
                                                    data?.ticket_detail?.selected_terms && Array.isArray(JSON.parse(data?.ticket_detail?.selected_terms)) &&
                                                    JSON.parse(data?.ticket_detail?.selected_terms).map((item, index) => (

                                                        <li>{item}</li>
                                                    ))
                                                }
                                            </ul>

                                        </div>
                                    </section>
                                </div>
                            </div>

                            {!expiredStatus &&
                                <div className="kitchen-singleticBtn-container">
                                    <div className="kitchen-singletic-price">
                                        <span>Total Price</span><br />
                                        <span> <span className="rupeeIcon">₹</span>{totalTicketPrice.toFixed(2)} </span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="kitchen-qty-selector">
                                            <button className="kitchen-qty-btn" onClick={decreaseQuantity}>-</button>
                                            <span className="kitchen-qty-val">{quantity}</span>
                                            <button className="kitchen-qty-btn" onClick={increaseQuantity}>+</button>
                                        </div>
                                        <button className="kitchen-singletic-buybtn" onClick={() =>
                                            userData?.user_type != "User" ? setShowModal(true) : openShippingModal()}  >
                                            Buy Now
                                            <span className="ms-3"><FaArrowRight /></span>
                                        </button>
                                    </div>
                                </div>
                            }

                        </div>
                    </>
                    :
                    (
                        <div className="p-3">

                            {/* Card */}
                            <div className="mb-3">
                                <Skeleton height={140} borderRadius={15} />
                            </div>

                            {/* Description */}
                            <div className="mb-3">
                                <Skeleton width={180} height={20} />
                                <Skeleton count={2} />
                            </div>

                            {/* Ticket Details */}
                            <div className="mb-3">
                                <Skeleton width={150} height={20} className="mb-2" />
                                <div className="d-flex justify-content-between      gap-2 flex-wrap">
                                    <Skeleton width={150} height={80} borderRadius={12} />
                                    <Skeleton width={150} height={80} borderRadius={12} />
                                    <Skeleton width={150} height={80} borderRadius={12} />
                                    <Skeleton width={150} height={80} borderRadius={12} />

                                </div>
                            </div>

                            {/* Product */}
                            <div className="mb-3">
                                <Skeleton width={120} height={20} className="mb-2" />
                                <div className="d-flex align-items-center p-2 border rounded">
                                    <Skeleton width={70} height={70} borderRadius={10} />
                                    <div className="ms-2 flex-grow-1">
                                        <Skeleton width={140} height={15} />
                                        <Skeleton width={100} height={12} />
                                        <Skeleton width={90} height={12} />
                                    </div>
                                </div>
                            </div>

                            {/* Terms */}
                            <div className="mb-3">
                                <Skeleton width={160} height={20} className="mb-2" />
                                <Skeleton count={5} />
                            </div>

                            {/* Button */}
                            <Skeleton height={50} borderRadius={30} />
                        </div>
                    )
            }

            <CenterLoginNavigateModal
                showModal={showModal}
                pathname={location.pathname}
                onclose={handleClose}
            />

            <div className="offcanvas offcanvas-bottomm main top_border_radius"
                ref={shippingtypeRef} style={{ maxHeight: "90vh", height: "auto", overflowY: "auto", }}>
                <div className="d-flex flex-column p-2">
                    <div className="p-2 flex-grow-1">
                        <div className="d-flex justify-content-between">
                            <h5 className="ff-poppins-semiBold fs-14 text-dark">
                                Select Your Preferred Delivery Type
                            </h5>
                            <p className="ff-poppins-regular fs-18 text-dark" onClick={() => closeShippingModal()}    >
                                <IoMdClose />
                            </p>
                        </div>

                        {(data?.ticket_detail.delivery_type == 1 ||
                            data?.ticket_detail.delivery_type == 3) && (
                                <div
                                    className={`${shipping_type == "1" ? "primary-box primary-text" : "secondary-box"} rounded-3`}
                                    onClick={() => setShiping_type("1")}
                                >
                                    <div className="d-flex justify-content-between align-items-center p-2">
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={shipping_type == "1" ? select_circle : unselect_circle}
                                                height="25"
                                                width="25"
                                                alt=""
                                            />
                                            <div className="ms-3">
                                                <h6 className="fs-13 m-0 ff-poppins-semiBold">Instore Pickup</h6>
                                                <p className="fs-11 m-0 ff-poppins-regular">
                                                    Hassle-free in-store pickup available!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        {(data?.ticket_detail.delivery_type == 2 ||
                            data?.ticket_detail.delivery_type == 3) && (
                                <div
                                    className={`${shipping_type == "2" ? "primary-box primary-text" : "secondary-box"} rounded-3 mt-2`}
                                    onClick={() => setShiping_type("2")}
                                >
                                    <div className="d-flex justify-content-between align-items-center p-2">
                                        <div className="d-flex align-items-center">
                                            <img src={shipping_type == "2" ? select_circle : unselect_circle} height="25" width="25" alt="" />
                                            <div className="ms-3">
                                                <h6 className="fs-13 m-0 ff-poppins-semiBold">Doorstep Delivery</h6>
                                                <p className="fs-11 m-0 ff-poppins-regular">
                                                    Delivery charges added extra
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>

                    <div className="p-2 mt-auto" >
                        <button disabled={!shipping_type}
                            className={`primary-bottom-btn rounded-3 fs-14 ff-poppins-medium ${shipping_type === "" ? "opacity_Cls secondary-bg-3" : ""}`}
                            onClick={() => (shipping_type ? add_to_cart() : null)} style={{ width: "100%" }}    >
                            Continue
                        </button>
                    </div>
                </div>
            </div>


            {isModalOpen && <div className="modal-backdrop fade show"></div>}


        </>
    )
}














